import { render, staticRenderFns } from "./InvitationItem.vue?vue&type=template&id=c357c380&scoped=true&"
import script from "./InvitationItem.vue?vue&type=script&lang=ts&"
export * from "./InvitationItem.vue?vue&type=script&lang=ts&"
import style0 from "./InvitationItem.vue?vue&type=style&index=0&id=c357c380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c357c380",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VListItem,VListItemAction,VListItemContent})
